import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    borderRadius: 32,
    overflow: "hidden",
    boxShadow: "0 20px 48px -8px rgba(4, 19, 112, 0.12)",
    backgroundColor: "#ffffff",
    width: "100%",
    maxWidth: 860,
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      // transform: "translateY(-4px)",
      boxShadow: "0 28px 60px -12px rgba(4, 19, 112, 0.18)",
    },
  },

  cardActionArea: {
    cursor: "default",
    "&:hover": {
      backgroundColor: "transparent",
    },
    "& .MuiTouchRipple-root": {
      display: "none",
    },
  },

  cardLayout: {
    display: "flex",
    flexDirection: "row",
    minHeight: 580,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },

  imageCol: {
    position: "relative",
    width: "50%",
    flexShrink: 0,
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: 320,
    },
  },

  cardImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    margin: 0,
    padding: 0,
    transition: "transform 0.4s ease",
    "$cardRoot:hover &": {
      transform: "scale(1.03)",
    },
  },

  retiredBadge: {
    position: "absolute",
    top: 20,
    left: 20,
    backgroundColor: "#041370",
    color: "#ffffff",
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "1.5px",
    userSelect: "none",
    zIndex: 2,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 35,
    padding: "0 18px",
    lineHeight: 0,
    textAlign: "center",
  },

  checkboxWrapper: {
    position: "absolute",
    bottom: 20,
    left: 20,
    backgroundColor: "rgba(255,255,255,0.9)",
    borderRadius: 8,
    zIndex: 2,
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,1)",
    },
  },

  checkbox: {
    color: "#041370",
    padding: 6,
  },

  contentCol: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    textAlign: "left",
    padding: theme.spacing(5, 5),
    backgroundColor: "#ffffff",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(4, 3),
    },
  },

  cardTitle: {
    color: "#041370",
    fontWeight: 900,
    fontSize: "2.5rem",
    lineHeight: 1.1,
    marginBottom: theme.spacing(2.5),
    textAlign: "left",

    [theme.breakpoints.down("sm")]: {
      fontSize: "1.8rem",
      textAlign: "left",
    },
  },

  onlyDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "inline",
    },
  },

  locationRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(4),
    cursor: "pointer",
    transition: "transform 0.2s ease",
    "&:hover": {
      transform: "translateX(2px)",
    },
    "&:hover $locationText": {
      textDecoration: "underline",
    },
  },

  locationIcon: {
    color: "#006F56",
    fontSize: 20,
    marginRight: 6,
    flexShrink: 0,
  },

  locationText: {
    color: "#006F56",
    fontWeight: 700,
    fontSize: "1.05rem",
    textAlign: "left",
  },

  fieldGroup: {
    marginBottom: theme.spacing(3),
    width: "100%",
  },

  fieldLabel: {
    color: "#8e9aaf",
    fontSize: 11,
    fontWeight: 800,
    letterSpacing: "1.3px",
    textTransform: "uppercase",
    marginBottom: theme.spacing(1),
    textAlign: "left",
    display: "block",
  },

  assetCode: {
    color: "#041370",
    fontSize: 22,
    fontWeight: 700,
    letterSpacing: "0.5px",
    textAlign: "left",
    cursor: "pointer",
    transition: "color 0.2s ease, transform 0.2s ease",
    "&:hover": {
      color: "#5869C5",
      transform: "translateX(2px)",
    },
  },

  metadataBox: {
    backgroundColor: "#f4f6fc",
    padding: theme.spacing(2.5, 3),
    borderRadius: 16,
    display: "flex",
    flexDirection: "column",
    gap: 8,
    width: "100%",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#eef1f9",
    },
  },

  metadataLink: {
    textDecoration: "none",
    textAlign: "left",
    transition: "transform 0.2s ease",
    "&:hover": {
      transform: "translateX(3px)",
    },
    "&:hover code": {
      color: "#5869C5",
    },
  },

  metadataCode: {
    fontSize: 13,
    color: "#4a5568",
    wordBreak: "break-all",
    lineHeight: 1.7,
    fontFamily: "monospace",
    display: "block",
    textAlign: "left",
  },

  actionArea: {
    marginTop: "auto",
    paddingTop: theme.spacing(3),
    width: "100%",
    paddingBottom: theme.spacing(3.2),
  },

  fabBtn: {
    width: "100%",
    backgroundColor: "#5869C5",
    color: "#ffffff",
    borderRadius: 16,
    padding: "12px 24px",
    minHeight: 64,
    boxShadow: "0 8px 20px rgba(88, 105, 197, 0.3)",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "16px",
    textTransform: "none",
    transition: "all 0.25s ease",
    "&:hover": {
      backgroundColor: "#041370",
      boxShadow: "0 12px 28px rgba(4, 19, 112, 0.4)",
      transform: "translateY(-3px)",
    },
    [theme.breakpoints.down("xs")]: {
      padding: "8px 16px",
      minHeight: 56,
    },
  },

  textWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    fontSize: 14,
    fontWeight: 800,
    lineHeight: 1.3,
    letterSpacing: "0.5px",
    textAlign: "center",
  },

  fabIcon: {
    fontSize: 24,
    flexShrink: 0,
  },
}));

export default useStyles;
